export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  error?: string;
}

export enum TwoFactorMethod {
  EMAIL = 'EMAIL',
  APP = 'APP',
  SMS = 'SMS',
}

export interface TwoFactorAuthRequiredResponseDTO {
  twoFactorRequired: boolean;
  methods: TwoFactorMethod[];
}

export interface TwoFactorAuthLoginVerifyRequestDTO {
  email: string;
  method: TwoFactorMethod;
  code: string;
}
